import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import GeneralSettings from "./GeneralSettings";
import GlobalSettings from "./GlobalSettings";
import Notification from "./Notification";

const AmtplSettings = () => {
  const [activeTab, setActiveTab] = useState("General Settings");
  const tabs = ["General Settings", "Global Settings", "Notification"];

  const renderTabContent = () => {
    switch (activeTab) {
      case "General Settings":
        return <GeneralSettings />;
      case "Global Settings":
        return <GlobalSettings />;
      case "Notification":
        return <Notification />;
      default:
        return <GeneralSettings />; // Added return statement
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">
          <main className="main-content">
            <div className="mb-3 main-tab">
              {tabs.map((tab) => (
                <button
                  key={tab}
                  className={`buttonclass ${
                    activeTab === tab ? "active" : "notactive"
                  }`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab}
                </button>
              ))}
            </div>
            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AmtplSettings;
